import { Component, input, output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ShamFi_xIcon, ShamHeartIcon } from 'sham-components/icons';

@Component({
  selector: 'app-cart-item-actions',
  imports: [TranslateModule, CommonModule, ShamHeartIcon, ShamFi_xIcon],
  templateUrl: './cart-item-actions.html',
  styleUrl: './cart-item-actions.css',
  standalone: true
})
export class CartItemActions {
  favorite = input(false);
  mobile = input(false);

  isCheckout = input(false);

  toggleFav = output();
  remove = output();
}
